<template>
  <div class="login">
    <b-container fluid="sm">
      <b-row class="justify-content-center vh-100" align-v="center">
        <b-col cols="12" md="6" lg="4" class="box-login">
          <login-options/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import './style.scss'
import LoginOptions from './loginOptions'

export default {
  name: 'Login',
  components: { LoginOptions },
  watch: {
    '$store.getters.errorsLogin': function () {
      if(this.$store.getters.errorsLogin?.auth){
        this.$toast.open({
          message: this.$store.getters.errorsLogin.auth,
          type: 'error'
        })
      }
    }
  }
}
</script>